import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils';

const pageType = 'special buy';

const getPrimaryCategory = (promoType = '') => ({
  sbotd: 'special buy of the day',
  decor: 'special buy of the week',
  pro: 'special buy of the week',
  '': 'unspecified special buy'
}[promoType]);

const getPageName = (promoType = '') => ({
  sbotd: 'special buy of the day',
  decor: 'special buy of the week decor',
  pro: 'special buy of the week pro',
  '': 'unspecified special buy'
}[promoType]);

const getProductInfoArray = (itemIds = []) => (
  itemIds.map((itemId) => ({
    productInfo: {
      sku: itemId
    }
  }))
);

const reportSpecialBuyPageLoad = ({ output: specialBuyData }) => {
  const promoType = specialBuyData?.promoType;
  const pageName = getPageName(promoType);

  digitalData.page = {
    category: {
      primaryCategory: getPrimaryCategory(promoType),
      subCategory1: pageName,
      subCategory2: pageName
    },
    pageInfo: {
      pageName,
      pageType
    }
  };

  digitalData.content = {
    product: getProductInfoArray(specialBuyData?.itemIds)
  };

  setAnalytics(digitalData);
};

const reportSpecialBuyCategoryNav = ({ output: specialBuyData }) => {
  const thdAnalyticsEvent = {
    category: {
      primaryCategory: 'interaction'
    },
    eventInfo: {
      eventName: 'category click'
    },
    content: {
      product: getProductInfoArray(specialBuyData?.itemIds)
    }
  };

  digitalData.event.push(thdAnalyticsEvent);
};

export const promotions = () => {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('specialBuy.page-load', reportSpecialBuyPageLoad);
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('specialBuy.category-nav', reportSpecialBuyCategoryNav);
};
